<template>
    <div :class="classObj" class="app-wrapper">
        <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
        <sidebar v-if="!isFullscreen" class="sidebar-container" />
        <div class="main-container" :class="{fullscreen: isFullscreen}">
            <div v-if="!isFullscreen" class="fixed-header" :class="{'is-have-scroll': isHaveScroll}">
                <navbar />
            </div>
            <app-main />
        </div>
    </div>
</template>

<script>
import { AppMain, Navbar, Sidebar } from "./components";
import { mapState } from "vuex";
import ResizeMixin from "./mixin/ResizeHandler";

export default {
    name: "Layout",
    components: {
        AppMain,
        Navbar,
        Sidebar
    },
    mixins: [ResizeMixin],
    computed: {
        ...mapState({
            sidebar: state => state.app.sidebar,
            device: state => state.app.device,
            isFullscreen: state => state.app.isFullscreen
        }),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation,
                mobile: this.device === "mobile"
            };
        }
    },
    data() {
        return {
            isHaveScroll: false
        };
    },
    watch: {
        $route(to, from) {
            this.hasScrollbar();
        }
    },
    mounted() {
        this.hasScrollbar();
    },
    methods: {
        handleClickOutside() {
            this.$store.dispatch("ToggleSideBar", { withoutAnimation: false });
        },

        hasScrollbar() {
            setTimeout(() => {
                this.isHaveScroll = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight);
            }, 2000);
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
        position: fixed;
        top: 0;
    }
}

.drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 1000;
}

.fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1001;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
}

.hideSidebar .fixed-header {
    width: calc(100% - 54px);
}

.mobile .fixed-header {
    width: 100%;
}
</style>
